export default __webpack_public_path__ + "static/install-istio2-b34aaa7533f9a9d9ed59cc5aeaec9c94.webp";